import { defineStore } from "pinia";

import { RecruitmentsService } from "@core/services";
import { ACTION_RECRUITMENT_GET_BY_ID, ACTION_RECRUITMENT_GET, ACTION_RECRUITMENT_RESET, GETTER_RECRUITMENT_GET_CURRENT } from "@etab/stores/types";
import { RecruitmentFactory } from "@core/models";

export const useRecruitmentStore = defineStore("recruitment", {
  // convert to a function
  state: () => ({
    recruitment: {},
  }),
  getters: {
    [GETTER_RECRUITMENT_GET_CURRENT]: (state) => new RecruitmentFactory(state.recruitment),
  },
  actions: {
    async [ACTION_RECRUITMENT_GET_BY_ID](demandId) {
      const recruitment = await RecruitmentsService.getById({ demandId });
      this.recruitment = recruitment;
    },
    async [ACTION_RECRUITMENT_GET]({ demandId, demandType }) {
      const recruitment = await RecruitmentsService.getRecruitmentDetail({ demandId, demandType });
      this.recruitment = recruitment;
    },
    [ACTION_RECRUITMENT_RESET]() {
      this.recruitment = {};
    },
    // easily reset state using `$reset`
    clearRecruitmentStore() {
      this.$reset();
    },
  },
});
